
import {Vue, Component} from 'vue-property-decorator';
import {ApplicationModule} from "@/store";
import accounting from "accounting";

@Component({})
export default class VehicleBannerV2 extends Vue {
	vehicle = ApplicationModule.vehicle;

	formatAsMoney(value:any) {
    return accounting.formatMoney(value, {
      symbol: '',
      precision: 0,
      thousand: ',',
      decimal: '.'
    }).replace('.00', '');
  }

  isBannerVisiable() {
    if( this.vehicle && this.vehicle.vrm && 
        ( this.vehicle.make || 
        this.vehicle.model || 
        this.vehicle.price ||
        this.vehicle.imageUrl ) ) {
      return true;
    }
    return false;
  }
  adjustTextHeight() {
    if( this.vehicle && this.vehicle.imageUrl ) {
      return false;
    }
    return true;
  }
}
